import React from "react";
import "./index.css";

const About = () => {
  return (
    <div className="about-container">
      <div>
        <h3>About Us</h3>
      </div>
      <div className="about-info">
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Excepturi
          doloribus hic beatae tempora exercitationem. In accusamus optio minima
          ipsum explicabo assumenda omnis deserunt veniam vitae, consequuntur
          tenetur aliquid ut maiores. Commodi sapiente iusto perferendis
          obcaecati qui odio, nesciunt quibusdam, amet culpa aperiam, laboriosam
          reiciendis velit. A quod odio tempore distinctio fugiat, aliquid
          molestias placeat cumque ducimus? Libero quos assumenda eaque.
        </p>
      </div>
    </div>
  );
};

export default About;
